import AdminVenueList from './venueList';

export default AdminVenueList;